import { render } from "./detail.vue?vue&type=template&id=0d3b28e0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=0d3b28e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d3b28e0"

export default script